import { useQuery } from "@apollo/client";
import { Link } from '@ambiguous/link';
import gqlMenu from "@assets/gql/menuIcon.gql";
import client from '../../apollo-client';
import React, { useEffect, useState } from "react";
import { IcomoonIcon } from "@acf/icon-picker/acf-icon-picker";
export default function MenuSocial({ menu, type, color, icon_size, prefetch }) {
    var _a, _b, _c;
    const [items, setItems] = useState([]);
    const { loading, data } = useQuery(gqlMenu, {
        variables: { id: menu },
        client,
        skip: !!((_c = (_b = (_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.menuItems) === null || _c === void 0 ? void 0 : _c.nodes),
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        let items;
        let prefetch_items = (_c = (_b = (_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.menuItems) === null || _c === void 0 ? void 0 : _c.nodes;
        if (prefetch_items) {
            items = prefetch_items;
        }
        else {
            items = (_e = (_d = data === null || data === void 0 ? void 0 : data.menu) === null || _d === void 0 ? void 0 : _d.menuItems) === null || _e === void 0 ? void 0 : _e.nodes;
        }
        if (!items)
            return;
        setItems(items);
    }, [data, prefetch]);
    if (loading)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: `ltg-menu-social menu--${type} ltg-menu-social--icons-${icon_size || 'default'}` }, items === null || items === void 0 ? void 0 : items.map(({ icon, id, label, path, target }) => {
        return (React.createElement(Link, { href: path, key: id, title: label, target: target, rel: target ? 'noopener noreferrer' : null, className: `btn btn-circle btn-circle-sm btn-${color || 'black'}` },
            React.createElement("span", { className: "sr-only" }, label),
            React.createElement(Icon, { icon: icon })));
    })));
}
function Icon({ icon }) {
    var _a;
    if (!icon)
        return React.createElement(React.Fragment, null);
    // LTG colored icon pack is rendered via `IcomoonIcon`, because multi-path icons
    // require `<span class="pathN">` children (plain `<i>` won't show colors).
    // Sometimes the stored value comes through as a css-like class `ltg-linkedin`.
    if ((_a = icon.iconClassName) === null || _a === void 0 ? void 0 : _a.startsWith('ltg-')) {
        const raw = icon.iconClassName.replace(/^ltg-/, '');
        const name = raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : raw;
        return React.createElement(IcomoonIcon, { name: name });
    }
    if (icon.iconPackType == 'icomoon') {
        return React.createElement(IcomoonIcon, { name: icon.iconName });
    }
    else {
        return React.createElement("i", { className: `${icon.iconPrefix} ${icon.iconClassName}` });
    }
}
